export const applyStyleToShadow = (styleID, shadowRoot) => {
  const link = document.querySelector(styleID);
  
  if (!link || !link?.sheet) {
    return;
  }
  
  const styleTag = document.createElement('style');
  let css = '';
  for(let rule of link.sheet.cssRules) {
    css += rule.cssText + '\n';
  }
  styleTag.id = link.id.toString();
  styleTag.innerHTML = css;
  shadowRoot.appendChild(styleTag);
  link.parentElement.removeChild(link);
}